import { useEffect } from 'react';
import { setSentryUser } from '@/services/sentry.ts';

const useSentry = (userEmail?: string) => {
  useEffect(() => {
    if (import.meta.env.MODE === 'development') {
      console.warn('Sentry is disabled in development mode.');
      return;
    }

    setSentryUser(userEmail);
  }, [userEmail]);
};

export default useSentry;
